'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diffSubscriptions = undefined;

var _diffPrimitives = require('../../utils/diffPrimitives');

var _pick = require('../../utils/pick');

var _transactSubscriptions = require('./transactSubscriptions');

var getDifference = function getDifference(a, b) {
  var diffChannels = (0, _diffPrimitives.diffPrimitives)(Object.keys(a), Object.keys(b));
  return (0, _pick.pick)(a, diffChannels);
};

/**
 * Diff currentSubscriptions and targetSubscriptions and update subscriptions
 *
 * @param {Object} options
 * @param {Object} options.vendor vendor api wrapper
 * @param {Object<channelId, messageCallback>} options.currentSubscriptions
 * @param {Object<channelId, messageCallback>} options.targetSubscriptions
 * @param {Number} options.playbackMessagesFrom - (Optional) Replay messages from history after this timestamp
 *
 * @returns {Promise}
 *
 */
var diffSubscriptions = exports.diffSubscriptions = function diffSubscriptions(_ref) {
  var vendor = _ref.vendor,
      currentSubscriptions = _ref.currentSubscriptions,
      targetSubscriptions = _ref.targetSubscriptions,
      playbackMessagesFrom = _ref.playbackMessagesFrom;

  var toAdd = getDifference(targetSubscriptions, currentSubscriptions);
  var toRemove = getDifference(currentSubscriptions, targetSubscriptions);

  return (0, _transactSubscriptions.transactSubscriptions)({
    vendor: vendor,
    toAdd: toAdd,
    toRemove: toRemove,
    playbackMessagesFrom: playbackMessagesFrom
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/conversations-pub-sub/client/diffSubscriptions.js
// module id = 797
// module chunks = 2 3